import * as React from 'react';
import { ITextAreaProps } from './ITextArea';

const TextArea = (props: ITextAreaProps) => {
    return (
        <>
            <label htmlFor={props.name}>{props.title}</label>
            <textarea id={props.name} name={props.name} value={props.value} rows={props.rows} cols={props.cols} placeholder={props.placeholder} disabled={props.disabled} onChange={props.onChange} />
        </>
    );
};

export default TextArea;
